import { render, staticRenderFns } from "./MoveDOTSPatient.vue?vue&type=template&id=25d823f6&scoped=true"
import script from "./MoveDOTSPatient.vue?vue&type=script&lang=js"
export * from "./MoveDOTSPatient.vue?vue&type=script&lang=js"
import style0 from "./MoveDOTSPatient.vue?vue&type=style&index=0&id=25d823f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d823f6",
  null
  
)

export default component.exports